"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedFilters = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
/**
 * Create new Saved Filter
 */
function createSavedFilter(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, savedFilter, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.savedFilters, {
            method: 'POST',
            body: savedFilter,
            workspaceId,
        });
    });
}
/**
 * Get Saved Filter
 */
function getSavedFilter(savedFilterId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.savedFilters, {
            method: 'GET',
            endpoint: `${savedFilterId}`,
        });
    });
}
/**
 * Update Saved Filter
 */
function updateSavedFilter(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, update, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.savedFilters, {
            method: 'PATCH',
            endpoint: `${update.id}`,
            body: update,
            workspaceId,
        });
    });
}
/**
 * Delete Saved Filter
 */
function deleteSavedFilter(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, savedFilterId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.savedFilters, {
            method: 'DELETE',
            endpoint: `${savedFilterId}`,
            workspaceId,
        });
    });
}
/**
 * List Saved Filters
 */
function listSavedFilters(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, options, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.savedFilters, {
            method: 'GET',
            endpoint: `?${(0, util_1.formatParamsForHttp)(options)}`,
            workspaceId,
        });
    });
}
/**
 * Move Saved Filters between other Saved Filters or before/after a Saved Filter
 * @param idsToMove Saved Filter ids to move
 * @param betweenIds.moveBeforeId SavedFilter id to move idsToMove before (end)
 * @param betweenIds.moveAfterId SavedFilter id to move idsToMove after (start)
 */
function updateSavedFilterPositions(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, update, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.savedFilters, {
            endpoint: `position`,
            method: 'PATCH',
            body: update,
            workspaceId,
        });
    });
}
exports.SavedFilters = {
    createSavedFilter,
    getSavedFilter,
    updateSavedFilter,
    deleteSavedFilter,
    listSavedFilters,
    updateSavedFilterPositions,
};
//# sourceMappingURL=savedFilters.js.map